<template>
  <el-skeleton
    class="cart-item__skeleton"
    :loading="true"
    animated
  >
    <template slot="template">
      <div class="cover">
        <el-skeleton-item variant="image" />
      </div>
      <div class="desc">
        <el-skeleton-item variant="p" />
        <el-skeleton-item variant="p" />
        <el-skeleton-item variant="p" />
      </div>
    </template>
  </el-skeleton>
</template>

<script>
export default {
  name: 'Book_Card'
}
</script>

<style lang="scss" scoped>
.cart-item__skeleton {
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.213);
  height: 100px;
  &::v-deep .el-skeleton {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    .cover {
      height: 90%;
      .el-skeleton__image {
        height: 100%;
        width: 75px;
      }
    }
    .desc {
      width: 100%;
      margin-left: 10px;
    }
  }
}
</style>
